import React from "react";

export default function NavButton({ active, onClick, icon: Icon, label }) {
  return (
    <button
      onClick={onClick}
      aria-current={active ? "page" : undefined}
      className={`nav-button flex flex-col items-center justify-center w-full p-2 transition-colors ${
        active ? "text-blue-600" : "text-slate-400 hover:text-slate-600"
      }`}
    >
      <Icon className={`w-5 h-5 mb-1 ${active ? "fill-blue-100" : ""}`} />
      <span className="text-[10px] font-medium">{label}</span>
    </button>
  );
}
